import React from 'react';
import { SimpleStepper } from '@ff-os/shared-react/components/stepper/SimpleStepper';
import { useStepsWindowNavigation } from '@ff-os/shared-react/components/window/StepsWindow';
import { ChangePhotoVariantMethod } from '../../thunks/changePhotoVariant';

export const useVariantStepper = (
    method: ChangePhotoVariantMethod | undefined,
    sizeId: string | undefined, paperId: string | undefined, borderId: string | undefined,
    showPaperStep: boolean, showBorderStep: boolean, withUploader = false,
    withMethod = false
) => {
    const stepOneDisabled = withMethod && !method;
    const stepTwoDisabled = stepOneDisabled || !sizeId;
    const stepThreeDisabled = stepTwoDisabled || !paperId;
    const stepFourDisabled = stepThreeDisabled || !borderId;

    const { ref, navigateTo } = useStepsWindowNavigation();

    const Stepper = ({ current }: { current: ChangeVariantStep }) => (
        <SimpleStepper
            current={current}
            navigateTo={navigateTo}
            hide={!showPaperStep && !withUploader}>

            {withMethod && (
                <SimpleStepper.Step name='photo_prints.options.method.title' isHidden />
            )}

            <SimpleStepper.Step name='photo_prints.options.size.name' isDisabled={stepOneDisabled} />

            {showPaperStep && (
                <SimpleStepper.Step name='photo_prints.options.paper.name' isDisabled={stepTwoDisabled} />
            )}

            {showBorderStep && (
                <SimpleStepper.Step name='photo_prints.options.border.name' isDisabled={stepTwoDisabled} />
            )}

            {withUploader && (
                <SimpleStepper.Step name='photo_prints.upload' isDisabled={stepFourDisabled} />
            )}
        </SimpleStepper>
    );

    return { ref, Stepper };
};

type ChangeVariantStep =
    | 'photo_prints.options.method.title'
    | 'photo_prints.options.size.name'
    | 'photo_prints.options.paper.name'
    | 'photo_prints.options.border.name'
    | 'photo_prints.upload'
    | 'photo_prints.done';